import { FixedRatios } from '@model';
import React from 'react';

export default function FixedRatioContainer({
  width = 1,
  height = 1,
  children = null,
  className,
  imgChild = false,
  ratio,
  ...props
}) {
  return (
    <div
      className={`fix-ratio-div ${className ? className : ''} ${
        imgChild ? 'with-img-child' : ''
      }`}
      style={
        ratio === 'auto'
          ? {
              '--fixed-ration': `${width} / ${height}`,
              '--img-wrapper-ratio': `${((height * 100) / width).toFixed(2)}%`,
              height: '83vh',
            }
          : {
              '--fixed-ration': `${width} / ${height}`,
              '--img-wrapper-ratio': `${((height * 100) / width).toFixed(2)}%`,
            }
      }
      {...props}
    >
      {children}
    </div>
  );
}

export function FixedRatioSectionWrapper({
  ratio = FixedRatios.FULL,
  imgChild = false,
  ...props
}) {
  let width = 64,
    height = 27;

  if (ratio === '32:7' || ratio === FixedRatios.BANNER) {
    width = 32;
    height = 7;
  } else if (ratio === '16:9' || ratio === FixedRatios.STANDARD) {
    width = 16;
    height = 9;
  } else if (ratio === 'auto' || ratio === FixedRatios.AUTO) {
    width = 64;
    height = 27;
  }

  return (
    <FixedRatioContainer
      width={width}
      height={height}
      imgChild={imgChild}
      ratio={ratio}
      {...props}
    />
  );
}
